module.exports = __webpack_public_path__ + "img/American-Credit-Vendor-Financing.2d26e59.png";